export const TICK = { fontSize: 11 };
export const TICK_MD = { fontSize: 12 };
export const TICK_MUTED = { fontSize: 11, fill: "#64748B" };
export const DOMAIN_AUTO = ["auto", "auto"];
export const DOMAIN_ZERO = [0, "auto"];
export const DOMAIN_RANGE = ["dataMin", "dataMax"];
export const BAR_RADIUS = [8, 8, 0, 0];
